/*
 * @Description: 查看项目人员列表 有四级、三级个人、三级个体区分
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import {
  downLoadTemplate,
  projectPersonnelManagement,
  checkProjectIsStart as checkProjectIsStartAjax,
  batchStatus,
  taxPayment
} from '@/api/ajax';
import fields, { struct1 as struct1Fields } from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import AddUser from '../child/add-user.vue';
import AddUserPark from '../child/add-user-park.vue';
import AddUsers from '../child/add-users.vue';
import AddUsersPark from '../child/add-users-park.vue';
import NameList from '../child/name-list';
import NameListPark from '../child/name-list-park';
import qs from 'qs';
import { isHistoryTask } from '@/page/project-personnel-inside/utils';
import createExtend from '@/components/createExtend.js';
import preBuy from '@/page/project-personnel-inside/list/child/pre-buy';
import store from '@/store';
import { checkV3NoSigned } from '../../../../methods/check';

const checkProjectIsStart = ctx => {
  return new Promise(async (resolve, reject) => {
    const {
      data: {
        data: { isStart, startDt }
      }
    } = await checkProjectIsStartAjax({
      projectId: ctx.$store.state.homeProject.id
    });
    if (!isStart) {
      ctx
        .$confirm(`项目开始时间：${startDt};是否确认继续导入`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          resolve('success');
        })
        .catch(() => {
          reject('fail');
        });
    } else {
      resolve('success');
    }
  });
};

const downloadHandler = {
  name: '名单下载',
  fn(_, ctx) {
    // ctx.handleSearch();
    let { id, type } = ctx.$store.state.homeProject;
    let { taskDt, fenpeiId } = ctx.$route.query;
    let isNowExecute = ctx.$parent.isNowExecute;
    // 调用sure同步query
    ctx.$refs.search.sure();
    let query = {
      ...ctx.searchQuery,
      type,
      projectId: id,
      fenpeiId,
      taskDt,
      isNowExecute
    };
    query = decodeURIComponent(qs.stringify(query));
    ctx.$downloadFile(
      `${downLoadTemplate.downloadTheList({}, true)}?${query}`,
      true
    );
  }
};
const moreHandler = {
  name: '名单操作',
  render(h, ctx) {
    let vm = ctx.parent;
    let taskDt = vm.$route.query.taskDt;
    let dialog = vm.$xrkDialog;
    let isDone = false;
    let _isHistoryTask = isHistoryTask(taskDt);
    let useDialog = ({ options, component, props }) => {
      return async () => {
        await checkV3NoSigned();
        await taxPayment.person.checkExportPersonnel({
          projectId: vm.$route.query.id
        });
        try {
          await checkProjectIsStart(vm);
          dialog.call(vm.$parent, {
            showConfirm: false,
            showCancel: false,
            ...options,
            $slots: {
              default: h(component, {
                props
              })
            }
          });
        } catch (error) {
          console.error('名单操作 error:', error);
        }
      };
    };
    const homeProject = vm.$store.state.homeProject;
    const {
      fileUpSource,
      fileUpMode,
      projectType,
      userEnterpriseType
    } = homeProject;
    // 选择上传来源为【我方上传-以活动形式上传】【双方共同上传】项目人员列表不显示名单操作按钮
    const isEntry = [+fileUpSource, +fileUpMode].join(',');
    const addUserButtonShow = !(
      ['1,1', '3,1'].includes(isEntry) && projectType === 19
    );
    const handleCommand = command => {
      command();
    };
    const dropdownList = [
      {
        name: '单独添加',
        disabled: isDone,
        command: useDialog({
          options: { title: '单独添加', width: '450px' },
          component: userEnterpriseType === 3 ? AddUserPark : AddUser
        })
      },
      {
        name: '名单库添加',
        disabled: isDone,
        command: useDialog({
          options: { title: '名单库添加', width: '1100px' },
          component: userEnterpriseType === 3 ? NameListPark : NameList
        })
      },
      {
        name: '批量添加',
        disabled: isDone,
        command: useDialog({
          options: {
            title: userEnterpriseType === 3 ? '批量添加(园区)' : '批量添加'
          },
          component: userEnterpriseType === 3 ? AddUsersPark : AddUsers
        })
      }
    ];
    return (
      addUserButtonShow && (
        <el-dropdown
          style="margin-left: 10px; margin-bottom: 10px;"
          onCommand={handleCommand}
        >
          <el-button type="primary" disabled={_isHistoryTask}>
            名单操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            {dropdownList.map(({ name, command, disabled }) => {
              return (
                <el-dropdown-item command={command} disabled={disabled}>
                  {name}
                </el-dropdown-item>
              );
            })}
          </el-dropdown-menu>
        </el-dropdown>
      )
    );
  }
};
const preBuyButton = {
  name: '预采购任务量',
  render(h, ctx) {
    const { projectType } = ctx.parent.$store.state.homeProject;
    // 如果是协定服务 19 不显示
    if (projectType === 19) {
      return <span></span>;
    }
    // 找到 table render 组件
    let parent = ctx.parent;
    while (parent.$parent) {
      parent = parent.$parent;
      if (parent.$options.name === 'table-render') {
        break;
      }
    }
    // 显示 预采购组件
    let clickHandler = async () => {
      await checkV3NoSigned();
      await taxPayment.person.checkExportPersonnel({
        projectId: ctx.parent.$route.query.id
      });
      try {
        await checkProjectIsStart(ctx.parent);
        await store.dispatch('syncProjectInfo');
        const preBuyComp = createExtend(preBuy);
        preBuyComp.$on('ok', () => {
          preBuyComp.remove();
          // window.location.reload(true);
          // 主要是获取 taskShowType 任务展示类型 累计/当期
          store.dispatch('syncProjectInfo');
          parent.init();
        });
      } catch (error) {
        console.error(error);
      }
    };
    return (
      <el-button
        type={'primary'}
        onClick={clickHandler}
        plain
        style="height:40px;margin-left:8px"
      >
        预采购任务量
      </el-button>
    );
  }
};
const batchOpen = {
  name: '批量启用',
  render(r, ctx) {
    const selection = ctx.parent.$parent.$parent.selection.map(v => v.userId);
    const fn = () => {
      let { id } = ctx.parent.$parent.$route.query;
      ctx.parent
        .$confirm('启用后，所选项目人员可以继续执行项目')
        .then(() => {
          batchStatus({
            projectId: id,
            userIds: selection,
            status: '1'
          }).then(() => {
            ctx.parent.$message.success('操作成功！');
            ctx.parent.$parent.handleSearch();
            ctx.parent.$parent.clearTableSelection();
            ctx.parent.$parent.$parent.selection = [];
          });
        })
        .catch(() => {});
    };
    return (
      <el-button
        class="btn"
        style="margin-left: 10px; margin-bottom: 10px;"
        type="warning"
        disabled={selection.length <= 0}
        plain
        onClick={() => {
          fn();
        }}
      >
        批量启用
      </el-button>
    );
  }
};
const batchClose = {
  name: '批量停用',
  render(r, ctx) {
    const selection = ctx.parent.$parent.$parent.selection.map(v => v.userId);
    const fn = () => {
      let { id } = ctx.parent.$parent.$route.query;
      ctx.parent
        .$confirm('停用后，所选项目人员将不能继续执行项目')
        .then(() => {
          batchStatus({
            projectId: id,
            userIds: selection,
            status: '2'
          }).then(() => {
            ctx.parent.$message.success('操作成功！');
            ctx.parent.$parent.handleSearch();
            ctx.parent.$parent.clearTableSelection();
            ctx.parent.$parent.$parent.selection = [];
          });
        })
        .catch(() => {});
    };
    return (
      <el-button
        class="btn"
        style="margin-left: 10px; margin-bottom: 10px;"
        type="warning"
        disabled={selection.length <= 0}
        plain
        onClick={() => {
          fn();
        }}
      >
        批量停用
      </el-button>
    );
  }
};
let example = new TableRenderClass({ fields, search });
let struct1Creator = new TableRenderClass({ fields: struct1Fields, search });
// structType:1
let part1Config = struct1Creator.createPart({
  name: '查看项目人员列表',
  list: projectPersonnelManagement.personnelList,
  search: [
    'fullName',
    'phone',
    'status',
    'personLabel',
    'openStatus',
    'userAuthStatus',
    'ifExecutableStatus',
    'certificationStatus'
  ],
  fields: [
    // 'userId',
    'selection',
    'index',
    'fullName',
    'fullNameAlter',
    'occupationAuthStatus',
    'openStatus',
    'phone',
    'personLabel',
    'taskPlanTaskDt',
    'taskPlanTaskSum',
    'passingTaskSumPlatform',
    'numberOfReceivedTasks',
    'csoPrice',
    'taskSumNoFinishPrice',
    'csoPriceTotal',
    'appPrice',
    'appPriceTotal',
    'inStatus',
    'certificationStatus',
    'status',
    'isNowExecute',
    'operation'
  ],
  moreBtnArr: [
    moreHandler,
    preBuyButton,
    downloadHandler,
    batchOpen,
    batchClose
  ]
});
// 三个体
let part2 = struct1Creator.createPart({
  name: '查看项目人员列表',
  // list: invoice.invoiceOpenList,
  list: projectPersonnelManagement.personnelList,
  search: [
    {
      width: 180,
      label: '经营者',
      tip: '请输入关键字',
      key: 'fullName',
      id: 'fullName',
      slot: 'input',
      clearable: true
    },
    'enterpriseName',
    'phone',
    'status',
    'personLabel',
    'openStatus',
    'userAuthStatus',
    'ifExecutableStatus',
    'certificationStatus'
  ],
  fields: [
    'selection',
    'index',
    {
      label: '经营者',
      prop: 'fullName'
    },
    'enterpriseName',
    'fullNameAlter',
    'occupationAuthStatus',
    'openStatus',
    'phone',
    'personLabel',
    'taskPlanTaskDt',
    'taskPlanTaskSum',
    'passingTaskSumPlatform',
    'numberOfReceivedTasks',
    'csoPrice',
    'taskSumNoFinishPrice',
    'csoPriceTotal',
    'appPrice',
    'appPriceTotal',
    'inStatus',
    'certificationStatus',
    'status',
    'isNowExecute',
    'operation'
  ],
  moreBtnArr: [
    moreHandler,
    preBuyButton,
    downloadHandler,
    batchOpen,
    batchClose
  ]
});
export const main1 = [{ name: '查看项目人员列表', childMenu: [part1Config] }];
export const main2 = [{ name: '查看项目人员列表', childMenu: [part2] }];
export const main3 = [{ name: '查看项目人员列表', childMenu: [part1Config] }];
// 方便后面使用
export default {
  1: main1,
  2: main2,
  3: main3
};
